import { NoAccessError } from "~/constants/errors"
import {
  hasStaffRole,
  permissionsForRoles,
  resolveEffectiveRoles,
  rolesFromClaim,
} from "~/server/api/utils/roles"
import { canOpenAllocation } from "~/utils/allocationAccess"
import { readSimulatedRole } from "~/utils/roleSimulation"

/**
 * Route guard for internal routes: allows only Hakio staff, determined by the
 * `hakio`/`staff` role in the JWT claim (not the email domain).
 *
 * Also blocks staff who are simulating a customer role, so /internal behaves
 * exactly as it would for that customer. Not a lockout risk: the role switcher
 * gates on the real JWT and a new tab is always un-simulated.
 * @param args Loader function arguments from TanStack Router
 */
// TODO: Make this type better!
export const internalRouteGuard = async ({ context }: any) => {
  if (!hasStaffRole(rolesFromClaim(context.auth.user)) || readSimulatedRole() !== null) {
    console.info("You dont have access to this page.")
    throw new NoAccessError()
  }
}

/**
 * Route guard for admin-tier routes (e.g. `/settings`): allows only roles that
 * grant `canAdminister` (customer `admin` and Hakio staff). Honors simulation,
 * so staff simulating a lower tier are blocked; simulating `admin` passes.
 */
// TODO: Make this type better!
export const adminRouteGuard = async ({ context }: any) => {
  const { effectiveRoles } = resolveEffectiveRoles(
    rolesFromClaim(context.auth.user),
    readSimulatedRole(),
  )
  if (!permissionsForRoles(effectiveRoles).canAdminister) {
    console.info("You dont have access to this page.")
    throw new NoAccessError()
  }
}

/**
 * Route guard for `/allocation`: Hakio staff, or an admin of an organization
 * allowed the Products report. Honors simulation.
 */
// TODO: Make this type better!
export const allocationRouteGuard = async ({ context }: any) => {
  const { effectiveRoles } = resolveEffectiveRoles(
    rolesFromClaim(context.auth.user),
    readSimulatedRole(),
  )
  const permissions = permissionsForRoles(effectiveRoles)
  if (!canOpenAllocation(context.auth.user?.org_name, permissions)) {
    console.info("You dont have access to this page.")
    throw new NoAccessError()
  }
}
